export type ThemeMode = "dark" | "light" | "system";

export const THEME_STORAGE_KEY = "intelligo.theme";
export const THEME_MODES: readonly ThemeMode[] = ["system", "light", "dark"];
export const DEFAULT_THEME_MODE: ThemeMode = "system";

export const applyThemeMode = (mode: ThemeMode): void => {
  const root = document.documentElement;
  if (mode === "light" || mode === "dark") {
    root.setAttribute("data-theme", mode);
    return;
  }
  root.removeAttribute("data-theme");
};

export const getInitialThemeMode = (): ThemeMode => {
  const savedTheme = window.localStorage.getItem(THEME_STORAGE_KEY);
  return THEME_MODES.includes(savedTheme as ThemeMode) ? (savedTheme as ThemeMode) : DEFAULT_THEME_MODE;
};

export const getNextThemeMode = (mode: ThemeMode): ThemeMode => {
  const currentIndex = THEME_MODES.indexOf(mode);
  return THEME_MODES[(currentIndex + 1) % THEME_MODES.length];
};
